<template>
  <div>
    <component :is="layout"> </component>
    <notify></notify>
  </div>
</template>

<script>
import notify from "@/components/app/notification";
import router from "@/router";
import store from "@/store";
const default_layout = "default";

export default {
  name: "App",

  components: {
    notify,
  },

  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + "-layout";
    },
  },

  created() {
    console.log("App.created()");
  },

  data: () => ({
    //
  }),

  router,
  store,

  watch: {
  },
};
</script>
<style lang="scss" scoped>
</style>
